<template>
	<div>
		<page :page="page" />
	</div>
</template>

<script>
	import store from "../store";
    import page from "./Page.vue";
    import products from "../services/products.js";

	export default {
		components: {
			page
		},
		data: function () {
			return {
				store: {},
				page: {}
			};
		},
		name: "Main",
		mounted: async function () {
			this.store = store;

			this.page = await products.load_main_page();
		},
	};
</script>

<style></style>
